import { Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import {fromPromise} from "rxjs/internal/observable/innerFrom";

@Injectable({
  providedIn: 'root',
})
export class PopOverService {
  constructor(private popOverController: PopoverController) {}

  /**
   * Create pop over with given Component and params for component.
   *
   * @param component component reference.
   * @param props input and output props for component.
   * @param cssClassName name of the css class for popover styling.
   */
  public showPopOver(
    component,
    props,
    cssClassName: string
  ): Observable<HTMLIonPopoverElement> {
    return fromPromise(
      this.popOverController.create({
        component,
        componentProps: props,
        cssClass: cssClassName,
      })
    );
  }

  /**
   * Dismiss Pop over.
   */
  public dismissPopOver(popover: HTMLIonPopoverElement) {
    fromPromise(popover.dismiss()).subscribe().unsubscribe();
  }
}
